import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportEventAccountOrderFulfillmentsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OrderFulfillmentFilter>;
}>;


export type ExportEventAccountOrderFulfillmentsQuery = { __typename?: 'Query', exportEventAccountOrderFulfillments: string };


export const ExportEventAccountOrderFulfillmentsDocument = gql`
    query ExportEventAccountOrderFulfillments($filter: OrderFulfillmentFilter) {
  exportEventAccountOrderFulfillments(filter: $filter)
}
    `;

/**
 * __useExportEventAccountOrderFulfillmentsQuery__
 *
 * To run a query within a React component, call `useExportEventAccountOrderFulfillmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEventAccountOrderFulfillmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEventAccountOrderFulfillmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportEventAccountOrderFulfillmentsQuery(baseOptions?: Apollo.QueryHookOptions<ExportEventAccountOrderFulfillmentsQuery, ExportEventAccountOrderFulfillmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportEventAccountOrderFulfillmentsQuery, ExportEventAccountOrderFulfillmentsQueryVariables>(ExportEventAccountOrderFulfillmentsDocument, options);
      }
export function useExportEventAccountOrderFulfillmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportEventAccountOrderFulfillmentsQuery, ExportEventAccountOrderFulfillmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportEventAccountOrderFulfillmentsQuery, ExportEventAccountOrderFulfillmentsQueryVariables>(ExportEventAccountOrderFulfillmentsDocument, options);
        }
export type ExportEventAccountOrderFulfillmentsQueryHookResult = ReturnType<typeof useExportEventAccountOrderFulfillmentsQuery>;
export type ExportEventAccountOrderFulfillmentsLazyQueryHookResult = ReturnType<typeof useExportEventAccountOrderFulfillmentsLazyQuery>;
export type ExportEventAccountOrderFulfillmentsQueryResult = Apollo.QueryResult<ExportEventAccountOrderFulfillmentsQuery, ExportEventAccountOrderFulfillmentsQueryVariables>;